import { render, staticRenderFns } from "./editInsurance.vue?vue&type=template&id=37066784"
import script from "./editInsurance.vue?vue&type=script&lang=js"
export * from "./editInsurance.vue?vue&type=script&lang=js"
import style0 from "./editInsurance.vue?vue&type=style&index=0&id=37066784&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports